<div [ngClass]="{ 'step-container-new': true, responsive: isResponsive }">
  <ul>
    <ng-container *ngFor="let step of steps; let i = index; trackBy: trackByIdentity">
      <li
        [ngClass]="{
          complete: i <= currentStepIndex,
          'current-step': steps[i].url === currentStep,
        }"
      >
        <div class="arrow-container">
          <a
            [routerLink]="step.url || ''"
            [ngClass]="{ disabled: i >= currentStepIndex || ignoreRoute }"
            (keydown.enter)="navigateLink($event)"
          >
            {{ i + 1 }}. {{ step.title }}
          </a>
        </div>
      </li>
    </ng-container>
  </ul>
</div>
